export default function HamburgerIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 6C14 6.25126 13.9115 6.49222 13.754 6.66989C13.5964 6.84756 13.3828 6.94737 13.16 6.94737H0.84C0.617218 6.94737 0.403561 6.84756 0.24603 6.66989C0.0884998 6.49222 0 6.25126 0 6C0 5.74874 0.0884998 5.50778 0.24603 5.33011C0.403561 5.15244 0.617218 5.05263 0.84 5.05263H13.16C13.3828 5.05263 13.5964 5.15244 13.754 5.33011C13.9115 5.50778 14 5.74874 14 6ZM0.84 1.89474H13.16C13.3828 1.89474 13.5964 1.79493 13.754 1.61726C13.9115 1.43959 14 1.19863 14 0.947368C14 0.696111 13.9115 0.455144 13.754 0.277478C13.5964 0.0998116 13.3828 0 13.16 0H0.84C0.617218 0 0.403561 0.0998116 0.24603 0.277478C0.0884998 0.455144 0 0.696111 0 0.947368C0 1.19863 0.0884998 1.43959 0.24603 1.61726C0.403561 1.79493 0.617218 1.89474 0.84 1.89474ZM13.16 10.1053H0.84C0.617218 10.1053 0.403561 10.2051 0.24603 10.3827C0.0884998 10.5604 0 10.8014 0 11.0526C0 11.3039 0.0884998 11.5449 0.24603 11.7225C0.403561 11.9002 0.617218 12 0.84 12H13.16C13.3828 12 13.5964 11.9002 13.754 11.7225C13.9115 11.5449 14 11.3039 14 11.0526C14 10.8014 13.9115 10.5604 13.754 10.3827C13.5964 10.2051 13.3828 10.1053 13.16 10.1053Z"
        fill="#131313"
      />
    </svg>
  );
}
